import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { useRef } from 'react';
import { convertDate } from '../../appconfig/AppHelper';

const ScrutinySuccessModal = (props: any) => {
    const toast = useRef<any>(null);

    const { fileNo, name, roleName, successDetails } = props.data;

    return (
        <>
            <Toast ref={toast} />

            <Dialog
                visible={props.openmodel}
                className="p-fluid"
                style={{ width: '600px' }}
                header={!window.cn(props.title) ? props.title : 'Scrutiny'}
                modal
                draggable={false}
                resizable={false}
                footer={
                    <>
                        <Button label="Go To App" icon="pi pi-check" className="p-button-primary" onClick={() => props.goToApp()} />
                    </>
                }
                onHide={() => props.goToApp()}
            >
                <div>
                    <img src="/assets/images/check.png" className="modal-img checkimg" alt="check" />

                    <div className="mx-auto modal_detail mt-2">
                        <p className="bold_label">Scrutiny Created Successfully</p>
                        <p>
                            <span className="bold_label">File No : </span> {atob(fileNo)}
                        </p>

                        {roleName === 'Registar' || roleName === 'Admin' ? (
                            <p>
                                <span className="bold_label">Reg No : </span>
                                {successDetails?.data?.RegNo}
                            </p>
                        ) : (
                            ''
                        )}

                        <p>
                            <span className="bold_label">Name : </span>
                            {name}
                        </p>

                        {successDetails?.validity && !window.cn(successDetails?.validity) && (
                            <p>
                                <span className="bold_label">Validity : </span>
                                {convertDate(successDetails?.validity)}
                            </p>
                        )}
                    </div>
                </div>
            </Dialog>
        </>
    );
};
export default ScrutinySuccessModal;
